import { useState, useMemo } from "react";

import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";

import { useAsync } from "../../../hooks/useAsync";

import useEquipmentService from "../../../services/equipmentService";

import BasicDialog from "../../base/BasicDialog";

import EquipmentTable from "../../table/EquipmentTable/EquipmentTable";
import { EQUIPMENT_INSTALATION_TABLE_CONFIG } from "./TableConfig";

import EquipmentInstalationDialog from "../EquipmentInstalationDialog/EquipmentInstalationDialog";

import useDialogWithId from "../../../hooks/useDialogWithId";
import LoaderWrapper from "../../wrapper/LoaderWrapper";

const EquipmentInstalationHistoryDialog = (props) => {
  const { t } = useTranslation();

  const tableConfig = useMemo(() => {
    let tableConfigTemp = EQUIPMENT_INSTALATION_TABLE_CONFIG;

    if (props.readOnly) {
      tableConfigTemp = tableConfigTemp.filter(
        (config) => config.name != "edit"
      );
    }

    return tableConfigTemp;
  }, [props.readOnly]);

  const [existChanges, setExistChanges] = useState(false);

  const [
    openEquipmentInstalationDialog,
    equipmentInstalationId,
    onOpenEquipmentInstalationDialog,
    onCloseEquipmentInstalationDialog,
  ] = useDialogWithId();

  const { getEquipmentInstalationsForEquipmentData } = useEquipmentService();

  const equipmentInstalationHistory = useAsync(
    () => getEquipmentInstalationsForEquipmentData(props.equipmentId),
    []
  );

  const onSumbitCallbackEquipmentInstalationDialog = (existChanges) => {
    if (existChanges) {
      setExistChanges(true);
      equipmentInstalationHistory.refetch();
    }
  };

  const handleClose = () => {
    if (existChanges && props.onSubmit) {
      props.onSubmit();
    }
    props.onClose();
  };

  const getDialogContent = () => {
    if (equipmentInstalationHistory.loading)
      return <LoaderWrapper showLoader={true} />;

    return (
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid item xs={12}>
          <EquipmentTable
            data={equipmentInstalationHistory.value}
            showCheckbox={false}
            showCleanFilterIcon={false}
            countRecords={equipmentInstalationHistory.value.length}
            style={{ maxHeight: "75vh" }}
            tableConfig={tableConfig}
            hiddenColumns={[]}
            columnsOrders={[]}
            showExportToFileButton={false}
            withPagination={false}
            showFilters={false}
            onClickMultipleLocationAlert={onOpenEquipmentInstalationDialog}
                  isLoading={equipmentInstalationHistory.loading}
                  showTableLoader={true}
          />
        </Grid>

        {openEquipmentInstalationDialog && (
          <EquipmentInstalationDialog
            open={openEquipmentInstalationDialog}
            onClose={onCloseEquipmentInstalationDialog}
            equipmentInstalationId={equipmentInstalationId}
            onSubmitCallback={onSumbitCallbackEquipmentInstalationDialog}
          />
        )}
      </Grid>
    );
  };

  return (
    <BasicDialog
      open={props.open}
      onClose={handleClose}
      titleAlign="center"
      title={t("dialog.equipment.equipment_instalation_history")}
    >
      {getDialogContent()}
    </BasicDialog>
  );
};

EquipmentInstalationHistoryDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  equipmentId: PropTypes.string,
};

EquipmentInstalationHistoryDialog.defaultProps = {};

export default EquipmentInstalationHistoryDialog;
